export default __webpack_public_path__ + "static/media/baby-2.0f5e60f1.svg";